import React, { useState, useEffect } from 'react';
import Sidebar, { MobileSidebar } from './Sidebar';
import Header from './Header';
import RightPanel from './RightPanel';
import ChatInterface from '../ChatInterface';

const MainLayout = ({ children, user, onLogout }) => {
  const [isRightPanelOpen, setIsRightPanelOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleRightPanel = () => {
    setIsRightPanelOpen(prev => !prev);
  };

  // Allow any child component to open the Niva panel via a custom event
  useEffect(() => {
    const handler = () => setIsRightPanelOpen(true);
    window.addEventListener('openNiva', handler);
    return () => window.removeEventListener('openNiva', handler);
  }, []);

  return (
    <div className="flex h-screen w-full bg-muted/40 overflow-hidden">
      <Sidebar user={user} onLogout={onLogout} onToggleAIAssistant={toggleRightPanel} />
      <MobileSidebar
        open={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        user={user}
        onLogout={onLogout}
        onToggleAIAssistant={toggleRightPanel}
      />
      <div className="flex flex-col flex-1 min-w-0 h-full">
        <Header user={user} onOpenMobileMenu={() => setIsMobileMenuOpen(true)} />
        <main className="flex flex-1 overflow-hidden">
          {/* Center Content Panel */}
          <div className="flex-1 flex justify-center overflow-y-auto p-4 md:p-6">
            <div className="w-full max-w-7xl">
              {children}
            </div>
          </div>
          <RightPanel
            isOpen={isRightPanelOpen}
            onClose={() => setIsRightPanelOpen(false)}
            title="AI Assistant"
          >
            <ChatInterface user={user} embedded={true} />
          </RightPanel>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
